import React, { useContext, useState } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import PlanCards from './PlanCards';
import FAQ from './FAQ';

const PlansBody = () => {
  return (
    <div className={container}>
      <PlanCards/>
      <FAQ/>
    </div>
  );
};

export default PlansBody;

const container = css`
  padding-top: 0;
  display: flex;
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding-top: 40px;
  }
`;
